export const SSO_TOKEN = 'sso_token'
export const SSO_USER_INFO = 'sso_user_info'

const serverUserURL = new Map([
  ['development', 'http://dev-crm-api.qixincha.com'],
  ['test', 'https://test-crm-api.qixincha.com'],
  ['production', 'https://crm-api.qixincha.com'],
])
const SCANA_CLIENT_HOST = {
  development: 'http://dev-scana-client.qixincha.com',
  test: 'https://test-scana-client.qixincha.com',
  production: 'https://scana.yunaq.com',
}
const SCANA_CLIENT_HOME_PAGE = '/view/home'

console.log('build Env: ', process.env.VUE_APP_BUILD)
export const SERVER_API_USER_NEWKMS = serverUserURL.get(process.env.VUE_APP_BUILD)
export const SCANA_CLIENT_HOME = SCANA_CLIENT_HOST[process.env.VUE_APP_BUILD] + SCANA_CLIENT_HOME_PAGE
